<template>
    <div class="watchdetail">
        <div class="wrap">
            <div class="left">
                <div class="left-t">
                     <el-row class="el-row" :gutter="20">
                        <el-col :span="8" align:center><div class="grid-content bg-purple grid-content-left" style="text-align:center;"><img :src="user" alt="" style="width:95%;height:92%;display:inline-block;vertical-align:middle;margin-top:px;border:1px solid rgb(243, 234, 234);"></div></el-col>
                        <el-col :span="16">
                            <div style="margin-top:5px;color:rgb(100, 92, 92);" class="grid-content bg-purple grid-content-right" v-if="oldmanList.oldName">姓名 :{{oldmanList.oldName}}</div>
                            <div style="margin-top:5px;color:rgb(100, 92, 92);" class="grid-content bg-purple grid-content-right"><span>年龄 :</span><span >{{oldmanList.oldAge}}</span><span>岁</span></div>
                            <div style="margin-top:5px;color:rgb(100, 92, 92);" class="grid-content bg-purple grid-content-right"><span>性别 :</span><span v-if="oldmanList.sex==0">男</span><span v-else>女</span></div>
                            <div style="margin-top:5px;color:rgb(100, 92, 92);" class="grid-content bg-purple grid-content-right"><span>出生日期 :</span><span>{{oldmanList.birthday}}</span></div>
                            <div style="margin-top:5px;color:rgb(100, 92, 92);" class="grid-content bg-purple grid-content-right"><span >电话号码 :</span><span>{{oldmanList.egPhonea}}</span></div>
                            <!-- <div class="grid-content bg-purple grid-content-right"><span>慢性病 :</span><span v-if="oldmanList.chronicDis==1">高血压</span><span>糖尿病</span></div>  -->
                            <div style="margin-top:5px;color:rgb(100, 92, 92);overflow:hidden;text-overflow:ellipsis;white-space: nowrap;" class="grid-content bg-purple grid-content-right"><span><img src="" alt=""></span><el-tooltip class="item" effect="dark" :content="oldmanList.oldAddress" placement="top-start"><span>家庭地址 :{{oldmanList.oldAddress}}</span></el-tooltip></div>  
                        </el-col>
                     </el-row>
                </div>
                <div class="left-b">
                     <span  class="menu-ctrl" :class="{active:active[index]}" v-for="(item,index) in tab" :key="index"  @click="change(index)">{{item.content}}</span>
                </div>
                <div class="jiebang-watch">
                    <el-row>
                        <el-col>
                            <!-- <el-button style="width:180px;height:50px;"  size="medium" type="danger" @click="handleJiebang">解除绑定</el-button> -->
                            <el-button style="width:380px;height:50px;font-size:20px;"  size="medium" @click="goback">返回</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="right">
                 <div :is="currentView"></div>
            </div>
	    </div>
    </div>
</template>
<script>
// 导入子组件
import child1 from '@/components/watch/Watchdetail-child1';
import child2 from '@/components/watch/Watchdetail-child2';
import child3 from '@/components/watch/Watchdetail-child3';
import child4 from '@/components/watch/Watchdetail-child4';
import user from '@/assets/common/touxiang.png'
export default {
    data () {
        return {
            deviceId:this.$route.query.id,//获取设备Id
            user:user,//引入图片
            oldmanList:{},//绑定的老人的信息
            oldName:"",//老人的名字
            currentView: 'child1',// 默认选中第一项
            active: [true, false, false,false,false],//统一管理状态;
            tab: [
                {
                    "content": "地图",　//tab-span
                    "func": "child1"    //仅仅用来存放组件;
                }, 
                {
                    "content": "计步",
                    "func": "child2"
                },
                {
                    "content": "心率",
                    "func": "child3"
                }, 
                {
                    "content": "睡眠",
                    "func": "child4"
                }, 
                // {
                //     "content": "智能提醒",
                //     "func": "child5"
                // },
            ] 
        };
    },
    methods: {
        change:function(x){        
            for(var i=0;i<this.active.length;i++){
                this.active[i]=false;
                this.active[x]=true;
                this.currentView=this.tab[x].func;
            }
            console.log(this.active);
            console.log(x);
            this.$set(this.active, 5, 0);
        },
        //获取所有老人信息
        getOldmanList(){
            this.oldName=unescape(this.$route.query.oldName);//通过query取到老人的姓名
            this.oldmanId=this.$route.query.oldmanId;//通过query取到老人的id
            console.log(this.oldName)
            console.log(this.oldmanId)
            let param={
              oldmanId:this.oldmanId
            }
            console.log(param)
            //by guo 2019-11-20-9:38修改
            //omc/OldmanCheckIn/selectById 变更为 omc/Oldman/selectOldManSupByOld  
            this.$postForm('omc/Oldman/selectOldManSupByOld', param).then((res) => {
                // var maninfo=res.result.oldBaseInfoMap;//by guo 2019-11-20-9:40修改
                var maninfo=res.result;
                console.log(maninfo);
                this.oldmanList=Object.assign({},maninfo)
            })
        },
        // 返回
        goback() {
            setTimeout(()=>{
                this.$router.go(-1);//返回上一层
                console.log("返回");
            },500)
           
        },
   },
   components: {
     child1,
     child2,
     child3,
     child4,
    //  child5
   },
   created(){
       this.getOldmanList();
   },
   mounted(){

   },
   updated: function() {
            this.who=null;
    },
}
</script>
<style lang="scss" scoped>
    .watchdetail{
        width:100%;
        height:100%;
        padding:20px 0 20px 5px;
        .wrap{display: flex;
            .left,.right{height: 620px;}
              border:1px solid rgb(243, 234, 234);
            .left{
                width: 400px;
                 border-right:1px solid rgb(243, 234, 234);
                .left-t{
                     padding:0px 20px;
                     .el-row{
                         margin:20px 0;
                         border:1px solid rgb(243, 234, 234);
                        .grid-content-left{
                        height:150px;
                        // background:pink;
                        text-align: center;
                    }    
                     }
                }
                .left-b{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 20px;
                        .menu-ctrl{
                            background:#fff;
                            display: inline-block;
                            width:340px;
                            height:24px;
                            line-height:24px;
                            text-align:center;
                            cursor:pointer;
                            color:rgb(100, 92, 92);
                            border:1px solid rgb(243, 234, 234);
                            padding:20px;
                            font-size: 20px;
                            font-weight:500;
                        }
                        .menu-ctrl.active{
                            color:#000;
                            background:#d8e5f8;
                        }
                        
                }
                .jiebang-watch{
                     display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }
            }
            .right{
                flex: 1;
                // background-color: greenyellow;
            }
        }
      
    }

    
</style>
